import axios from "../plugins/axios";

const apiConfig = process.env.VUE_APP_API_HOST;

/**
 * 登入用
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export const LoginApi = (data) => {
  return axios.post(`${apiConfig}/member/login`, data);
};

/**
 * 重複取得token用
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export const ReTokenApi = (data) => {
  return axios.put(`${apiConfig}/member/reToken`, data);
};

// 取得會員資料
export const GetUserInfoApi = () => {
  return axios.get(`${apiConfig}/member/getInfo`);
};

/**
 * 登出用
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export const LogoutApi = () => {
  return axios.get(`${apiConfig}/member/logout`);
};

// 驗證是否會員可以註冊
export const AddUserRegisterApi = (data) => {
  return axios.post(`${apiConfig}/checkMemberAvailability`, data);
};